'use client';

import { c as _c } from "react/compiler-runtime";
import { HousePerson, NavArrowDown } from '@byway/icons';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { ChangeOriginModal } from '~/components/TripOverview/booking/ChangeOriginModal';
import { useTripOriginUpdate } from '~/components/TripOverview/hooks/useTripOriginUpdate';
import styles from './ChangeOriginButton.module.css';
type ChangeOriginButtonProps = {
  originName: string;
  tripId: string;
};
export function ChangeOriginButton(t0) {
  const $ = _c(25);
  const {
    originName,
    tripId
  } = t0;
  const t = useTranslations("journey");
  const {
    confirmOrigin
  } = useTripOriginUpdate();
  const [isOpen, setIsOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <HousePerson size="small" width={22} height={22} decorative={true} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== t) {
    t2 = t("overview_booking_card_origin");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== originName) {
    t3 = <strong>{originName}</strong>;
    $[3] = originName;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <span>{t2}: {t3}</span>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = isOpen ? `${styles.chevron} ${styles.chevronOpen}` : styles.chevron;
  let t6;
  if ($[8] !== t5) {
    t6 = <NavArrowDown decorative={true} size="small" className={t5} />;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t4 || $[11] !== t6) {
    t7 = <>{t1}{t4}{t6}</>;
    $[10] = t4;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const buttonContent = t7;
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => setIsOpen(true);
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== buttonContent) {
    t9 = <button type="button" className={styles.originButton} data-test-id="change-origin-button" onClick={t8}>{buttonContent}</button>;
    $[14] = buttonContent;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => setIsOpen(false);
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== confirmOrigin || $[18] !== isOpen || $[19] !== originName || $[20] !== tripId) {
    t11 = <ChangeOriginModal isOpen={isOpen} close={t10} currentOrigin={originName} tripId={tripId} onConfirm={confirmOrigin} />;
    $[17] = confirmOrigin;
    $[18] = isOpen;
    $[19] = originName;
    $[20] = tripId;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11 || $[23] !== t9) {
    t12 = <>{t9}{t11}</>;
    $[22] = t11;
    $[23] = t9;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  return t12;
}